import { Alert } from './alert'

export interface RealtimeAlertsState {
	list: Array<Alert>
}

export enum REALTIME_ALERTS_ACTION_TYPES {
	GET = 'REALTIME_ALERTS_GET',
}

export interface RealtimeAlertsGetAction {
	type: REALTIME_ALERTS_ACTION_TYPES.GET
	payload: Array<Alert>
}

export type RealtimeAlertsAction = RealtimeAlertsGetAction
